<template>
  <div class="row">
    <div class="col">
      <h2 class="titre">Consultation Jeux</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Numéro de dossier :</label>
        </div>
        <div class="col txt">
          <p v-if="!numeroCardexAfficher"> ... </p>
          <p v-else> {{ numeroCardexAfficher }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Catégorie :</label>
        </div>
        <div class="col txt">
          <p v-if="!categorieAfficher"> ... </p>
          <p v-else> {{ categorieAfficher }} </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Jeux choisis :</label>
    </div>
    <div class="col txt">
      <p> <span v-for="jeu in this.listesJeux" :key="jeu">
        {{ jeu }}
        <br/>
      </span></p>
    </div>
  </div>
  <ButtonBarJeux :actionAccesDecision="actionAccesDecision"
                 @fermer="fermer" @modifier="modifier"/>
</template>

<script>
import ButtonBarJeux from '../../../components/dossier/Consulter/ButtonBarJeux.vue'
import axios from 'axios';
import {mapGetters} from 'vuex';

export default {
  name: 'consulterJeux',
  components: {
    ButtonBarJeux,
  },
  mounted() {
    this.isDataLoading = true;

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consulter Jeux");
    this.getJeux();
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      actionAccesDecision: "dossier/actionAccesDecision",
      jeuxLiees: 'dossier/jeuxLiees',
      dossier: 'dossier/dossier',
    })
  },
  data() {
    return {
      isDataLoading: false,
      typeAfficher: null,
      categorieAfficher: null,
      numeroCardexAfficher: null,
      listesJeux: [],
    };
  },
  methods: {
    assignerJeux(list) {
      this.categorieAfficher = this.dossier.categorieAfficher;
      this.numeroCardexAfficher = this.dossier.numeroCardexAfficher;
      list.forEach(je => {
        this.listesJeux.push(je.jeuxAfficher)
      });
    },
    getJeux() {
      this.$store
          .dispatch("jeux/consulterJeuxAction", {
            cle: this.$route.params.cleDossier,
            site: this.$route.params.siteDossier
          })
          .then((res) => {
            this.assignerJeux(res.data.entites);
            this.isDataLoading = false;
          });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    modifier() {
      this.$router.push({
        name: "modifierJeux",
        params: {
          cleDossier: this.$route.params.cleDossier,
          siteDossier: this.$route.params.siteDossier
        },
      });
    },
  },
};
</script>